export default __webpack_public_path__ + "static/media/logo_facebook.765b2daf.svg";